// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Container":"Container-3mcb11jqyk2ucc2ej17gr9bq934gue9nmuhwxzm5m9c7tveg22vfvyn4z1wu33v9qgcxskph4rsdasyanw2un5uq3kuxm5bux7dyb5k","loading":"loading-3fcx9eyfpwdbckpzs4f5nzth5wq9j51j5f1tjn2m5b2m2rhh154ddwr69rpxsadv5gkuts2f7zznh3zw4n5npwcrr1hnj1bp6hsp644","pulse":"pulse-p785fetunvuj67cdkjs91muc56kz36a4eksymuad5rvaw18cmkpzhdqznuev2ztzr9ks95vywd2yganxr1ufgtf9fu1aa5fy3p9kvg"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/Home.module.scss
// module id = 1121
// module chunks = 0